import(/* webpackMode: "eager" */ "/app/src/app/tools/json-formatter/page.tsx");
